// extracted by mini-css-extract-plugin
export default {"address":"Address_address__y2g5D","form":"Address_form__Hevsc","flexip":"Address_flexip__FTmDQ","flexbtn":"Address_flexbtn__YtQWm","flexp":"Address_flexp__Y0jav"};